import "styles/components/videos/videoPlayer.scss"

const injectEmbed = ({ el, videoId, autoPlay = false }) => {
  const autoplay = autoPlay ? 1 : 0

  el.classList.add("videoPlayer--busy")

  const iframeTag = document.createElement("iframe")
  iframeTag.id = `vimeoIframe-${videoId}`
  iframeTag.setAttribute("frameborder", 0)
  iframeTag.setAttribute("webkitallowfullscreen", 1)
  iframeTag.setAttribute("mozallowfullscreen", 1)
  iframeTag.setAttribute("allowfullscreen", 1)
  iframeTag.setAttribute("allow", "autoplay,fullscreen")
  iframeTag.onload = event => {
    el.classList.remove("videoPlayer--busy")
  }
  iframeTag.src = `https://player.vimeo.com/video/${videoId}?color=cc4e29&autoplay=${autoplay}&title=0&byline=0&portrait=0&muted=1`
  el.querySelector(".videoPlayer__embedHolder").appendChild(iframeTag)

  el.classList.add("videoPlayer--active")
}

const VimeoEmbed = el => {
  const { videourl, autoload } = el.dataset
  // TODO: backend should return only video id not the full url
  let videoId = null
  const vimeoRegex = /(http|https)?:\/\/(www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|)(\d+)(?:|\/\?)/

  if (vimeoRegex.test(videourl)) {
    videoId = vimeoRegex.exec(videourl)
    videoId = videoId[4]
  }

  console.log(videourl, videoId, vimeoRegex.test(videourl))

  if (videoId) {
    if (autoload !== undefined) {
      injectEmbed({
        el,
        videoId,
        autoPlay: true
      })
    } else {
      $(el).one("click", ".videoPlayer__playVideoBtn", event => {
        event.preventDefault()
        injectEmbed({
          el,
          videoId,
          autoPlay: true
        })
      })
    }

    const vimeoApiScriptTag = document.querySelector("#vimeoPlayerApi")
    if (vimeoApiScriptTag === null) {
      const firstTag = document.getElementsByTagName("script")[0]
      const scriptTag = document.createElement("script")

      scriptTag.id = "vimeoPlayerApi"
      scriptTag.src = "https://player.vimeo.com/api/player.js"
      firstTag.parentNode.insertBefore(scriptTag, firstTag)
    }
  }
}

export { VimeoEmbed }
